import { twMerge } from "tailwind-merge";
import { RoomMember } from "@platform/features/video/types/video.types";
import { VideoUITileNameplateType } from "./VideoUITileNameplateType";

export type Props = {
  nameplate: string;
  isWithContentShare: boolean;
  isWithVideo: boolean;
  className?: string;
  roomMemberData?: RoomMember | null;
  isXs?: boolean;
  containerWidth?: number;
};

export function VideoUITileNameplate({
  nameplate,
  isWithContentShare,
  isWithVideo,
  className,
  roomMemberData,
  isXs,
  containerWidth,
}: Props) {
  return (
    <div
      className={twMerge(
        "absolute bottom-1.5 left-1.5 max-w-[calc(100%-2rem)] px-3 py-2 rounded-md bg-brand-900/90 backdrop-blur",
        isWithContentShare && "bottom-1 left-1 px-2 py-1.5",
        isWithVideo &&
          containerWidth &&
          containerWidth < 400 &&
          "opacity-0 transition-opacity duration-200 group-hover:opacity-100",
        className
      )}
    >
      <VideoUITileNameplateType
        nameplate={nameplate}
        isWithContentShare={isWithContentShare}
        isWithVideo={isWithVideo}
        roomMemberData={roomMemberData}
        isXs={isXs}
        containerWidth={containerWidth}
      />
    </div>
  );
}

export default VideoUITileNameplate;
